<template>
  <div>
    <b-row class="mb-4">
      <b-col>
        <fcc-select v-model="fase" :options="listaFases" :clearable="false">
          Fase
        </fcc-select></b-col
      >
      <b-col>
        <fcc-select
          v-model="aplicacao"
          :options="listaAplicacoes"
          :disabled="!fase"
          :clearable="false"
        >
          Aplicação
        </fcc-select>
      </b-col>
    </b-row>

    <b-row align-h="end">
      <b-col class="mb-3 text-right">
        <fcc-button :disabled="!fase || !aplicacao" @click="filtrarPorFaseAplicacao"
          >Buscar</fcc-button
        >
      </b-col>
    </b-row>

    <div class="card p-3 mb-3" v-if="items.length > 0">
      <b-row>
        <b-col>
          <fcc-table
            striped
            hover
            pdf
            xls
            csv
            responsive
            search
            pagination
            field-visibility
            :titlePage="titlePage"
            :titlePDF="titlePage"
            :fields="fieldsAlocacao"
            :orderby="sortBy"
            :items="items"
            :porPage="itemPorPage"
            :key="keyTable"
            @row-selected="selecionaItems"
          />
        </b-col>
      </b-row>

      <b-row align-h="end">
        <b-col class="mb-3 text-right">
          <fcc-button :disabled="dadosSelecionados.length <= 0" @click="importarAlocacao"
            >Importar</fcc-button
          >
        </b-col>
      </b-row>
    </div>

    <fcc-logs-importacao
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="tpImportacao"
      :logs="logs"
      @excluir="excluirImportacaoAlocacao"
    />
  </div>
</template>

<script>
import axios from 'axios'
import FccLogsImportacao from './fccLogsImportacao.vue'
import fccGravarLog from './fccGravarLog.vue'

export default {
  mixins: [fccGravarLog],
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object,
    tpImportacao: Number,
    fasesEAplicacoes: Array,
    listaFases: Array
  },
  data() {
    return {
      titlePage: 'Importação de Candidatos - Alocação',
      fase: '',
      aplicacao: '',
      listaAplicacoes: [],
      sortBy: 'nome',
      itemPorPage: '10',
      items: [],
      fieldsAlocacao: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'idpublicacao', label: 'Publicação', sortable: true },
        { key: 'idoutfase', label: 'Outras Fases', sortable: true },
        { key: 'idfase', label: 'Fase', sortable: true },
        { key: 'idaplic', label: 'Aplicação', sortable: true },
        { key: 'codgaplic', label: 'Código Aplicação', sortable: true },
        { key: 'grupo', label: 'Grupo', sortable: true },
        { key: 'ninscricoes', label: 'N° Inscrições', sortable: true, totalizar: true },
        { key: 'importados', label: 'N° Importados', sortable: true, totalizar: true }
      ],
      dadosSelecionados: [],
      logs: [],
      keyTable: 0
    }
  },
  components: {
    FccLogsImportacao
  },
  created() {
    this.listarLogs()
  },
  watch: {
    fase(value) {
      this.listaAplicacoes = this.fasesEAplicacoes
        .filter((item) => item.idfase === value)
        .map((item) => item.idaplic)
      this.aplicacao = ''
      this.items = []
    }
  },
  methods: {
    filtrarPorFaseAplicacao() {
      const body = {
        id_Publicacao: this.controlePage.idpublicacao,
        id_Outrafase: this.idoutfase,
        id_Fase: this.fase,
        id_Aplic: this.aplicacao
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/FiltrarPorFaseAplicacao',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          if (data.length === 0) {
            this.callAlert('A busca não retornou resultados.', '', 'error', 'error')
          }
          this.items = data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    selecionaItems(value) {
      this.dadosSelecionados = value
    },
    importarAlocacao() {
      const body = {
        id_Publicacao: this.controlePage.idpublicacao,
        id_Outrafase: this.idoutfase,
        id_Fase: this.fase,
        id_Aplic: this.aplicacao,
        tpImportacaoOutrasFases: this.tpImportacao,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario,
        codgsAplic: this.dadosSelecionados.map((item) => item.codgaplic)
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ImportarAlocacao',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Importado com sucesso.', 'success')
          this.keyTable = this.keyTable + 1
          this.gravarLogImportacaoCandidatosOutrasFases()

          this.filtrarPorFaseAplicacao()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    excluirImportacaoAlocacao() {
      const body = {
        id_Publicacao: this.controlePage.idpublicacao,
        id_Outrafase: this.idoutfase,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ExcluirImportacaoAlocacao',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.excluido, 'success')
          this.listarLogs()
          if (this.fase && this.aplicacao) this.filtrarPorFaseAplicacao()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarLogs() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ListarLogsImportacao',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_Outrafase: this.idoutfase
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.logs = data
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>